module.exports = __webpack_public_path__ + "static/media/arrow-grey.2fb42528.svg";